<div *ngIf="businesstripApplication?.travelData?.countrySelected?.defaulttext" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.country"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.countrySelected?.defaulttext}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.destination" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.destination"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.destination}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.travelManagementPurpose" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.purpose"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.travelManagementPurpose}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.destinationFreetext" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplicationdCosts.BusinesstripApplication.travelData.destinationfreetext"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.destinationFreetext}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.billingbasisSelected?.defaulttext" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.billingbasis"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.billingbasisSelected?.defaulttext}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.arrivalSelected?.defaulttext" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.arrival"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.arrivalSelected?.defaulttext}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.tripBeginDate" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.tripBeginDate"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.tripBeginDate | hisDate: dateTimeFormat}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.returnTripSelected?.defaulttext" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.returnTrip"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.returnTripSelected?.defaulttext}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.tripEndDate" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.tripEndDate"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.tripEndDate | hisDate: dateTimeFormat}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.businessBeginDate" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.businessBeginDate"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.businessBeginDate | hisDate: dateTimeFormat}}</span>
    </div>
</div>

<div *ngIf="businesstripApplication?.travelData?.businessEndDate" class="layoutBlock">
    <div class="columnDetailLabel detailPresentationListLabel">
        <span>{{
            "rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelData.businessEndDate"
            | hisUi }}</span>
    </div>
    <div class="columnDetailContent detailPresentationListContent">
        <span>{{businesstripApplication?.travelData?.businessEndDate | hisDate: dateTimeFormat}}</span>
    </div>
</div>